module.exports = __webpack_public_path__ + "img/bg-error.03c43241.jpg";